import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ChangeDetectionStrategy,
} from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
import { Subscription, skip } from "rxjs";
import { AuthenticationService } from "../../../shared/services/authentication.service";
import { LocalStorageService } from "../../../shared/services/local-storage.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FooterComponent implements OnInit, OnDestroy {
  // /feedback is behind AuthGuard, so the footer link is only rendered for
  // logged-in visitors. Starts null (SSR / prerender renders no link) and is
  // set in the browser after a deferral, same pattern as HeaderComponent, so
  // hydration never sees both branches.
  loggedIn: boolean | null = null;

  private loggedInSub?: Subscription;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private authService: AuthenticationService,
    private storageService: LocalStorageService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.loggedIn = !!this.storageService.getItem("token");
        this.cdr.detectChanges();
      }, 0);

      // The footer lives in the app shell and survives login/logout without
      // a reload, so follow the auth state like the header does.
      this.loggedInSub = this.authService.isLoggedIn
        .pipe(skip(1))
        .subscribe((loggedIn) => {
          this.loggedIn = loggedIn;
          this.cdr.detectChanges();
        });
    }
  }

  ngOnDestroy() {
    this.loggedInSub?.unsubscribe();
  }
}
